import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Modal, ModalFooter, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../hooks/useTranslation';
function ConfirmationModal({ onConfirm, onClose, open, bodyText }) {
    useTranslation();
    const confirmHandler = () => {
        onClose();
        onConfirm();
    };
    const modalBodyText = () => _jsx(Typography, { children: $t(bodyText) });
    const modalFooter = () => (_jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", onClick: onClose, children: $t('No') }), _jsx(Button, { onClick: confirmHandler, children: $t('Yes') })] }) }));
    return (_jsx(Modal, { size: "sm", open: open, modalHeader: $t('Confirmation'), modalFooter: modalFooter(), onClose: onClose, children: modalBodyText() }));
}
export default ConfirmationModal;
